import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { Alert, Button, Field, Input } from "@/components/ui";
import { errorMessage } from "@/lib/api";

import { useAuth } from "./AuthContext";

export function LoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const from = (location.state as { from?: string } | null)?.from ?? "/";

  if (user) return <Navigate to={from} replace />;

  return (
    <div className="flex min-h-full items-center justify-center bg-canvas px-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2.5">
          <img src="/favicon.svg" alt="" className="h-8 w-8" />
          <div>
            <div className="text-base font-semibold leading-5">Dataliva AI Gateway</div>
            <div className="text-xs text-ink-3">Yönetim Konsolu</div>
          </div>
        </div>
        <form
          className="space-y-4 rounded-md border border-line bg-surface p-6"
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true);
            setError(null);
            try {
              await login(email, password);
              navigate(from, { replace: true });
            } catch (err) {
              setError(errorMessage(err));
            } finally {
              setBusy(false);
            }
          }}
        >
          <h1 className="text-lg font-semibold">Oturum aç</h1>
          {error && <Alert tone="bad">{error}</Alert>}
          <Field label="E-posta">
            <Input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </Field>
          <Field label="Parola">
            <Input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </Field>
          <Button type="submit" variant="primary" className="w-full" loading={busy}>
            Giriş yap
          </Button>
        </form>
        <p className="mt-4 text-center text-xs text-ink-3">Yalnızca yetkili sistem yöneticileri içindir. Tüm işlemler denetim kaydına yazılır.</p>
      </div>
    </div>
  );
}
